import React, { createContext, useContext, useState, useCallback } from "react";

const TourContext = createContext(null);

export function TourProvider({ children }) {
  const [tour, setTour] = useState(null);

  const startTour = useCallback((steps, screenTitle) => {
    setTour({ steps, screenTitle, currentStep: 0 });
  }, []);

  const nextStep = useCallback(() => {
    setTour((prev) => {
      if (!prev) return null;
      const next = prev.currentStep + 1;
      if (next >= prev.steps.length) return null;
      return { ...prev, currentStep: next };
    });
  }, []);

  const prevStep = useCallback(() => {
    setTour((prev) => {
      if (!prev) return null;
      const next = Math.max(0, prev.currentStep - 1);
      return { ...prev, currentStep: next };
    });
  }, []);

  const goToStep = useCallback((idx) => {
    setTour((prev) => {
      if (!prev) return null;
      return { ...prev, currentStep: idx };
    });
  }, []);

  const endTour = useCallback(() => {
    setTour(null);
  }, []);

  return (
    <TourContext.Provider value={{ tour, startTour, nextStep, prevStep, goToStep, endTour }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const ctx = useContext(TourContext);
  if (!ctx) {
    throw new Error("useTour must be used within a TourProvider");
  }
  return ctx;
}
